import * as Bluebird from 'bluebird';
import Vue from 'vue';

declare global {
    export interface Promise<T> extends Bluebird<T> {

    }
}


declare module 'vue/types/vue' {
    export interface VueConstructor<V extends Vue = Vue> {
      nonreactive(value: any): any;
    }

}

const Observer = (new Vue()).$data
    .__ob__
    .constructor;

Vue.nonreactive = (value: any) => {
    // Set dummy observer on value
  value.__ob__ = new Observer({});
  return value;
};







// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/lib_import.ts